// extracted by mini-css-extract-plugin
export default {"-large":"text-masking-panel-module__-large--n0A6d","smallTool":"text-masking-panel-module__smallTool--lyIk4","bigTool":"text-masking-panel-module__bigTool--EVRCC"};